<template>
  <div>
    <div class="text-block" v-html="bodyContent"/>
  </div>
</template>

<script>
import PrismicDOM from 'prismic-dom'

export default {
  name: 'content-text',
  props: ['content'],
  computed: {
    bodyContent () {
      if (this.content.primary.dropcap && this.content.primary.dropcap.length > 0) {
        return `<div class="drop-cap">${this.content.primary.dropcap}</div> ${this.getHtmlContent(this.content.primary.text)}`
      } else {
        return this.getHtmlContent(this.content.primary.text)
      }
    }
  },
  methods: {
    linkResolver (doc) {
      return `#/post/${doc.slug}`
    },
    getTextContent (str) {
      return str ? PrismicDOM.RichText.asText(str) : ''
    },
    getHtmlContent (str) {
      return str ? PrismicDOM.RichText.asHtml(str, this.linkResolver) : ''
    }
  }
}
</script>

<style lang="scss">

h3 {
  font-size: 1.6rem;

  @media (min-width: $breakpoint-lg) {
    font-size: 1.8rem;
  }
}

h4 {
  font-size: 1.6rem;

  @media (min-width: $breakpoint-lg) {
    font-size: 1.8rem;
  }
}

.text-block [data-oembed-type="video"] {
  position: relative;
  padding-bottom: 56.25%; /* 16:9 */
  padding-top: 25px;
  height: 0;
}

.text-block [data-oembed-type="video"] iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.drop-cap {
  position: relative;
  color: #fff;
  font-family: $font-heading;
  font-weight: 700;
  font-size: 2.4rem;
  float: left;
  line-height: 88px;
  height: 70px;
  margin: 0 2rem 1rem 1rem;
  padding: 0;
  text-align: center;
  width: 70px;


  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0px;
    z-index: z('drop-cap');
    width: 70px;
    height: 70px;
    background-color: $leadership;
    transform: rotate(45deg);
  }

  .leadership & {
    &:before {
      background-color: $leadership;
    }
  }

  .legal-market & {
    &:before {
      background-color: $legal-market;
    }
  }

  .legal-tech & {
    &:before {
      background-color: $legal-tech;
    }
  }

  .management & {
    &:before {
      background-color: $management;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Text.vue?1a639bb8